"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { ShoppingBag } from "lucide-react"
import { rutaDeLaCesta } from "@/lib/mercado/rutas"
import type { Idioma } from "@/lib/landing/idioma"
import { alCambiarLaCesta, leerCesta, unidadesEnCesta } from "./cesta-local"
import { textosMercado } from "./textos"

/** El acceso a la cesta, con cuantas cosas lleva. Sin nada dentro no se enseña. */
export function EnlaceCesta({ sobreOscuro = false, idioma = "es" }: { sobreOscuro?: boolean; idioma?: Idioma }) {
  const [unidades, setUnidades] = useState(0)

  useEffect(() => {
    const leer = () => setUnidades(unidadesEnCesta(leerCesta()))
    leer()
    return alCambiarLaCesta(leer)
  }, [])

  if (!unidades) return null
  return (
    <Link
      href={rutaDeLaCesta(idioma)}
      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors ${
        sobreOscuro ? "bg-white text-zinc-950 hover:bg-zinc-200" : "bg-zinc-950 text-white hover:bg-zinc-800"
      }`}
    >
      <ShoppingBag className="h-4 w-4" aria-hidden />
      {textosMercado(idioma).cesta} · {unidades}
    </Link>
  )
}
